import { axiosInstance } from "./config";

export default {
  state: {
    house_gallery: {},
  },
  mutations: {
    Set_house_gallery(state, payload) {
      state.house_gallery = payload;
    },
    Set_update_house_gallery(state, payload) {
      state.house_gallery.find((g) => g.id == payload.id).image = payload.image;
      state.house_gallery.find((g) => g.id == payload.id).newImage = undefined;
    },
  },
  actions: {
    async Get_house_gallery({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/house_gallery${payload}`)
        .then(function (data) {
          commit("Set_house_gallery", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_house_gallery(commit, payload) {
      return await axiosInstance
        .post("/house_gallery", payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_house_gallery({ commit }, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/house_gallery/" + payload.id, formData, config)
        .then(function (data) {
          commit("Set_update_house_gallery", data?.data?.data);
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_house_gallery(commit, payload) {
      return await axiosInstance
        .put("/house_gallery/" + payload.id)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
  },
  getters: {
    g_house_gallery: (state) => state.house_gallery,
  },
};
